import { call, put, takeLatest } from "redux-saga/effects";
import * as api from "../constants/api";
import {
	APV3_PENDING,
	APV3_ERROR,
	APV3_GET_CAMPAIGNS,
	SG_APV3_GET_CAMPAIGNS,
	APV3_CREATE_CAMPAIGN,
	SG_APV3_CREATE_CAMPAIGN,
	APV3_FETCH_CAMPAIGN,
	SG_APV3_FETCH_CAMPAIGN,
	APV3_UPDATE_CAMPAIGN,
	SG_APV3_UPDATE_CAMPAIGN,
	APV3_ADD_MANAGERS,
	SG_APV3_ADD_MANAGERS,
	APV3_ADD_SURVEY_MANAGERS,
	SG_APV3_ADD_SURVEY_MANAGERS,
	APV3_REMOVE_SURVEY_MANAGERS,
	SG_APV3_REMOVE_SURVEY_MANAGERS,
	APV3_ADD_GROUPS,
	SG_APV3_ADD_GROUPS,
	APV3_ADVANCE_PHASE,
	SG_APV3_ADVANCE_PHASE,
	APV3_GET_CAMPAIGN_SUMMARY,
	SG_APV3_GET_CAMPAIGN_SUMMARY,
	APV3_GET_REPORTS,
	SG_APV3_GET_REPORTS,
	APV3_GET_AVAILABLE_DEBRIEF_REPORTS,
	SG_APV3_GET_AVAILABLE_DEBRIEF_REPORTS,
	APV3_FETCH_REPORT,
	SG_APV3_FETCH_REPORT,
	APV3_APPROVE_REPORT,
	SG_APV3_APPROVE_REPORT,
	APV3_REJECT_REPORT,
	SG_APV3_REJECT_REPORT,
	APV3_SEND_REPORT_NOW,
	SG_APV3_SEND_REPORT_NOW,
	APV3_GET_REPORTS_PENDING_REVIEW,
	SG_APV3_GET_REPORTS_PENDING_REVIEW,
  APV3_START_REPORT_GENERATION,
  SG_APV3_START_REPORT_GENERATION,
	SG_APV3_CONFIGURE_EMAIL_TEMPLATE,
	SG_APV3_VALIDATE_EMAIL_TEMPLATES,
	APV3_VALIDATE_EMAIL_TEMPLATES,
	APV3_GET_EVENTS,
	SG_APV3_GET_EVENTS,
	APV3_CREATE_EVENT,
	SG_APV3_CREATE_EVENT,
	APV3_FETCH_EVENT,
	SG_APV3_FETCH_EVENT,
	APV3_LAUNCH_EVENT,
	SG_APV3_LAUNCH_EVENT,
	APV3_CLOSE_EVENT,
	SG_APV3_CLOSE_EVENT,
	APV3_GET_EVENT_RESPONSES,
	SG_APV3_GET_EVENT_RESPONSES,
	APV3_GET_ACTIONS,
	SG_APV3_GET_ACTIONS,
	APV3_CREATE_ACTION,
	SG_APV3_CREATE_ACTION,
	APV3_UPDATE_PROGRESS,
	SG_APV3_UPDATE_PROGRESS,
	APV3_ADD_ASSIGNEES,
	SG_APV3_ADD_ASSIGNEES,
	APV3_GET_ACTION_UPDATES,
	SG_APV3_GET_ACTION_UPDATES,
	APV3_GET_AT_RISK_ACTIONS,
	SG_APV3_GET_AT_RISK_ACTIONS,
	APV3_CREATE_UPDATE,
	SG_APV3_CREATE_UPDATE,
	APV3_GET_ANALYTICS,
	SG_APV3_GET_ANALYTICS,
	APV3_RECALCULATE_ANALYTICS,
	SG_APV3_RECALCULATE_ANALYTICS,
	APV3_GET_DASHBOARD_OVERVIEW,
	SG_APV3_GET_DASHBOARD_OVERVIEW,
	APV3_GET_RECENT_ACTIVITY,
	SG_APV3_GET_RECENT_ACTIVITY,
	APV3_GET_MANAGER_REPORTS,
	SG_APV3_GET_MANAGER_REPORTS,
	APV3_GET_MANAGER_ACTIONS,
	SG_APV3_GET_MANAGER_ACTIONS,
	APV3_GET_MANAGER_EVENTS,
	SG_APV3_GET_MANAGER_EVENTS,
	APV3_UPDATE_EVENT,
	SG_APV3_UPDATE_EVENT,
	APV3_GET_REMINDER_SCHEDULE,
	SG_APV3_GET_REMINDER_SCHEDULE,
	APV3_UPSERT_REMINDER,
	SG_APV3_UPSERT_REMINDER,
	APV3_DELETE_REMINDER,
	SG_APV3_DELETE_REMINDER,
	APV3_GET_EMAIL_LOGS_BY_CAMPAIGN,
	SG_APV3_GET_EMAIL_LOGS_BY_CAMPAIGN,
} from "../constants/actions";

function* safeCall(apiFn, payload, successType) {
	try {
		yield put({ type: APV3_PENDING });
		const response = yield call(apiFn, payload);
		yield put({ type: successType, payload: response.data });
	} catch (error) {
		yield put({ type: APV3_ERROR, payload: error?.response || error });
	}
}

// Campaigns
function* getCampaigns(action) { yield* safeCall(api.APV3_GET_CAMPAIGNS, action.payload, APV3_GET_CAMPAIGNS); }
function* createCampaign(action) { yield* safeCall(api.APV3_CREATE_CAMPAIGN, action.payload, APV3_CREATE_CAMPAIGN); }
function* fetchCampaign(action) { yield* safeCall(api.APV3_FETCH_CAMPAIGN, action.payload, APV3_FETCH_CAMPAIGN); }
function* updateCampaign(action) { yield* safeCall(api.APV3_UPDATE_CAMPAIGN, action.payload, APV3_UPDATE_CAMPAIGN); }
function* addManagers(action) { yield* safeCall(api.APV3_ADD_MANAGERS, action.payload, APV3_ADD_MANAGERS); }
function* addSurveyManagers(action) {
	try {
		yield put({ type: APV3_PENDING });
		const response = yield call(api.APV3_ADD_SURVEY_MANAGERS, action.payload);
		// Pass along manager_objects from the action payload so reducer can merge them immediately
		yield put({ type: APV3_ADD_SURVEY_MANAGERS, payload: { ...response.data, manager_objects: action.payload.manager_objects } });
	} catch (error) {
		yield put({ type: APV3_ERROR, payload: error?.response || error });
	}
}
function* removeSurveyManagers(action) {
	try {
		yield put({ type: APV3_PENDING });
		const response = yield call(api.APV3_REMOVE_SURVEY_MANAGERS, action.payload);
		// Pass along manager_ids from the action payload so reducer can remove them immediately
		yield put({ type: APV3_REMOVE_SURVEY_MANAGERS, payload: { ...response.data, manager_ids: action.payload.manager_ids } });
	} catch (error) {
		yield put({ type: APV3_ERROR, payload: error?.response || error });
	}
}
function* addGroups(action) { yield* safeCall(api.APV3_ADD_GROUPS, action.payload, APV3_ADD_GROUPS); }
function* advancePhase(action) { yield* safeCall(api.APV3_ADVANCE_PHASE, action.payload, APV3_ADVANCE_PHASE); }
function* getCampaignSummary(action) { yield* safeCall(api.APV3_GET_CAMPAIGN_SUMMARY, action.payload, APV3_GET_CAMPAIGN_SUMMARY); }
// Configure report delivery email template
function* configureCampaignEmailTemplate(action) { yield* safeCall(api.APV3_CONFIGURE_CAMPAIGN_EMAIL_TEMPLATE, action.payload, "APV3_CONFIGURE_EMAIL_TEMPLATE"); }
// Validate email templates configured for a campaign
function* validateEmailTemplates(action) {
	yield* safeCall(api.APV3_VALIDATE_EMAIL_TEMPLATES, action.payload, APV3_VALIDATE_EMAIL_TEMPLATES);
	// After validation, refresh campaign summary without overwriting state with validation payload
	try {
		yield put({ type: SG_APV3_GET_CAMPAIGN_SUMMARY, payload: { id: action.payload?.id } });
	} catch (e) {}
}

// Reports
function* getReports(action) { yield* safeCall(api.APV3_GET_REPORTS, action.payload, APV3_GET_REPORTS); }
function* getAvailableDebriefReports() { yield* safeCall(api.APV3_GET_AVAILABLE_DEBRIEF_REPORTS, undefined, APV3_GET_AVAILABLE_DEBRIEF_REPORTS); }
function* fetchReport(action) { yield* safeCall(api.APV3_FETCH_REPORT, action.payload, APV3_FETCH_REPORT); }
function* approveReport(action) { yield* safeCall(api.APV3_APPROVE_REPORT, action.payload, APV3_APPROVE_REPORT); }
function* rejectReport(action) { yield* safeCall(api.APV3_REJECT_REPORT, action.payload, APV3_REJECT_REPORT); }
function* sendReportNow(action) { yield* safeCall(api.APV3_SEND_REPORT_NOW, action.payload, APV3_SEND_REPORT_NOW); }
function* getPendingReports(action) { yield* safeCall(api.APV3_GET_REPORTS_PENDING_REVIEW, action.payload, APV3_GET_REPORTS_PENDING_REVIEW); }

// Start report generation for a campaign
function* startReportGeneration(action) { yield* safeCall(api.APV3_START_REPORT_GENERATION, action.payload, APV3_START_REPORT_GENERATION); }

// Events
function* getEvents(action) { yield* safeCall(api.APV3_GET_EVENTS, action.payload, APV3_GET_EVENTS); }
function* createEvent(action) { yield* safeCall(api.APV3_CREATE_EVENT, action.payload, APV3_CREATE_EVENT); }
function* fetchEvent(action) { yield* safeCall(api.APV3_FETCH_EVENT, action.payload, APV3_FETCH_EVENT); }
function* launchEvent(action) { yield* safeCall(api.APV3_LAUNCH_EVENT, action.payload, APV3_LAUNCH_EVENT); }
function* closeEvent(action) { yield* safeCall(api.APV3_CLOSE_EVENT, action.payload, APV3_CLOSE_EVENT); }
function* getEventResponses(action) { yield* safeCall(api.APV3_GET_EVENT_RESPONSES, action.payload, APV3_GET_EVENT_RESPONSES); }

// Event update and reminders
function* updateEvent(action) { yield* safeCall(api.APV3_UPDATE_EVENT, action.payload, APV3_UPDATE_EVENT); }
function* getReminderSchedule(action) { yield* safeCall(api.APV3_GET_REMINDER_SCHEDULE, action.payload, APV3_GET_REMINDER_SCHEDULE); }
function* upsertReminder(action) { yield* safeCall(api.APV3_UPSERT_REMINDER, action.payload, APV3_UPSERT_REMINDER); }
function* deleteReminder(action) { yield* safeCall(api.APV3_DELETE_REMINDER, action.payload, APV3_DELETE_REMINDER); }

// Actions
function* getActions(action) { yield* safeCall(api.APV3_GET_ACTIONS, action.payload, APV3_GET_ACTIONS); }
function* createAction(action) { yield* safeCall(api.APV3_CREATE_ACTION, action.payload, APV3_CREATE_ACTION); }
function* updateProgress(action) { yield* safeCall(api.APV3_UPDATE_PROGRESS, action.payload, APV3_UPDATE_PROGRESS); }
function* addAssignees(action) { yield* safeCall(api.APV3_ADD_ASSIGNEES, action.payload, APV3_ADD_ASSIGNEES); }
function* getActionUpdates(action) { yield* safeCall(api.APV3_GET_ACTION_UPDATES, action.payload, APV3_GET_ACTION_UPDATES); }
function* getAtRiskActions(action) { yield* safeCall(api.APV3_GET_AT_RISK_ACTIONS, action.payload, APV3_GET_AT_RISK_ACTIONS); }

// Updates
function* createUpdate(action) { yield* safeCall(api.APV3_CREATE_UPDATE, action.payload, APV3_CREATE_UPDATE); }

// Analytics
function* getAnalytics(action) { yield* safeCall(api.APV3_GET_ANALYTICS, action.payload, APV3_GET_ANALYTICS); }
function* recalcAnalytics(action) { yield* safeCall(api.APV3_RECALCULATE_ANALYTICS, action.payload, APV3_RECALCULATE_ANALYTICS); }

// Dashboard
function* getOverview() { yield* safeCall(api.APV3_GET_DASHBOARD_OVERVIEW, undefined, APV3_GET_DASHBOARD_OVERVIEW); }
function* getRecentActivity() { yield* safeCall(api.APV3_GET_RECENT_ACTIVITY, undefined, APV3_GET_RECENT_ACTIVITY); }

// Manager
function* getManagerReports(action) { yield* safeCall(api.APV3_GET_MANAGER_REPORTS, action.payload, APV3_GET_MANAGER_REPORTS); }
function* getManagerActions(action) { yield* safeCall(api.APV3_GET_MANAGER_ACTIONS, action.payload, APV3_GET_MANAGER_ACTIONS); }
function* getManagerEvents(action) { yield* safeCall(api.APV3_GET_MANAGER_EVENTS, action.payload, APV3_GET_MANAGER_EVENTS); }

// Email logs by campaign (diagnostic fetch)
function* getEmailLogsByCampaign(action) { yield* safeCall(api.APV3_GET_EMAIL_LOGS_BY_CAMPAIGN, action.payload, APV3_GET_EMAIL_LOGS_BY_CAMPAIGN); }

export default function* ActionPlanningV3() {
	yield takeLatest(SG_APV3_GET_CAMPAIGNS, getCampaigns);
	yield takeLatest(SG_APV3_CREATE_CAMPAIGN, createCampaign);
	yield takeLatest(SG_APV3_FETCH_CAMPAIGN, fetchCampaign);
	yield takeLatest(SG_APV3_UPDATE_CAMPAIGN, updateCampaign);
	yield takeLatest(SG_APV3_ADD_MANAGERS, addManagers);
	yield takeLatest(SG_APV3_ADD_SURVEY_MANAGERS, addSurveyManagers);
	yield takeLatest(SG_APV3_REMOVE_SURVEY_MANAGERS, removeSurveyManagers);
	yield takeLatest(SG_APV3_ADD_GROUPS, addGroups);
	yield takeLatest(SG_APV3_ADVANCE_PHASE, advancePhase);
	yield takeLatest(SG_APV3_GET_CAMPAIGN_SUMMARY, getCampaignSummary);
  yield takeLatest(SG_APV3_CONFIGURE_EMAIL_TEMPLATE, configureCampaignEmailTemplate);
  yield takeLatest(SG_APV3_VALIDATE_EMAIL_TEMPLATES, validateEmailTemplates);

	yield takeLatest(SG_APV3_GET_REPORTS, getReports);
	yield takeLatest(SG_APV3_GET_AVAILABLE_DEBRIEF_REPORTS, getAvailableDebriefReports);
	yield takeLatest(SG_APV3_FETCH_REPORT, fetchReport);
	yield takeLatest(SG_APV3_APPROVE_REPORT, approveReport);
	yield takeLatest(SG_APV3_REJECT_REPORT, rejectReport);
	yield takeLatest(SG_APV3_SEND_REPORT_NOW, sendReportNow);
	yield takeLatest(SG_APV3_GET_REPORTS_PENDING_REVIEW, getPendingReports);
  yield takeLatest(SG_APV3_START_REPORT_GENERATION, startReportGeneration);

	yield takeLatest(SG_APV3_GET_EVENTS, getEvents);
	yield takeLatest(SG_APV3_CREATE_EVENT, createEvent);
	yield takeLatest(SG_APV3_FETCH_EVENT, fetchEvent);
	yield takeLatest(SG_APV3_LAUNCH_EVENT, launchEvent);
	yield takeLatest(SG_APV3_CLOSE_EVENT, closeEvent);
	yield takeLatest(SG_APV3_GET_EVENT_RESPONSES, getEventResponses);
	yield takeLatest(SG_APV3_UPDATE_EVENT, updateEvent);
	yield takeLatest(SG_APV3_GET_REMINDER_SCHEDULE, getReminderSchedule);
	yield takeLatest(SG_APV3_UPSERT_REMINDER, upsertReminder);
	yield takeLatest(SG_APV3_DELETE_REMINDER, deleteReminder);

	yield takeLatest(SG_APV3_GET_ACTIONS, getActions);
	yield takeLatest(SG_APV3_CREATE_ACTION, createAction);
	yield takeLatest(SG_APV3_UPDATE_PROGRESS, updateProgress);
	yield takeLatest(SG_APV3_ADD_ASSIGNEES, addAssignees);
	yield takeLatest(SG_APV3_GET_ACTION_UPDATES, getActionUpdates);
	yield takeLatest(SG_APV3_GET_AT_RISK_ACTIONS, getAtRiskActions);

	yield takeLatest(SG_APV3_CREATE_UPDATE, createUpdate);

	yield takeLatest(SG_APV3_GET_ANALYTICS, getAnalytics);
	yield takeLatest(SG_APV3_RECALCULATE_ANALYTICS, recalcAnalytics);

	yield takeLatest(SG_APV3_GET_DASHBOARD_OVERVIEW, getOverview);
	yield takeLatest(SG_APV3_GET_RECENT_ACTIVITY, getRecentActivity);

	yield takeLatest(SG_APV3_GET_MANAGER_REPORTS, getManagerReports);
	yield takeLatest(SG_APV3_GET_MANAGER_ACTIONS, getManagerActions);
	yield takeLatest(SG_APV3_GET_MANAGER_EVENTS, getManagerEvents);
  yield takeLatest(SG_APV3_GET_EMAIL_LOGS_BY_CAMPAIGN, getEmailLogsByCampaign);
}


